"use strict";

exports.__esModule = true;
exports.SortableRows = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SortableRow = require("./SortableRow");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SortableRows = exports.SortableRows = function SortableRows(_ref) {
  var items = _ref.items,
    renderItem = _ref.renderItem,
    setItems = _ref.setItems,
    renderSubRow = _ref.renderSubRow,
    getKey = _ref.getKey,
    Container = _ref.Container,
    _ref$canDelete = _ref.canDelete,
    canDelete = _ref$canDelete === void 0 ? function () {
      return true;
    } : _ref$canDelete,
    onDelete = _ref.onDelete;
  var _useState = (0, _react.useState)(0),
    dropIndex = _useState[0],
    setDropIndex = _useState[1];
  var content = items.map(function (item, index, array) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SortableRow.SortableRow, {
      key: getKey && getKey(item, index),
      "data-testid": getKey && getKey(item, index),
      onDragEnd: function onDragEnd() {
        var newArray = array.slice();
        newArray.splice(index, 1);
        newArray.splice(dropIndex, 0, item);
        setItems(newArray);
      },
      onDragLeave: function onDragLeave() {
        return setDropIndex(index);
      },
      deleteSelf: function deleteSelf() {
        if (canDelete(item)) {
          setItems(array.filter(function (v) {
            return v !== item;
          }));
        } else {
          onDelete(item);
        }
      }
    }, renderItem(item, index, array)), renderSubRow && renderSubRow(item, index, array));
  });
  if (Container) {
    content = content.map(function (element) {
      return /*#__PURE__*/_react["default"].createElement(Container, {
        key: element.key
      }, element);
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, content);
};